import * as TypeGraphQL from "type-graphql";
export var ModelArtifactScalarFieldEnum;
(function (ModelArtifactScalarFieldEnum) {
    ModelArtifactScalarFieldEnum["id"] = "id";
    ModelArtifactScalarFieldEnum["modelName"] = "modelName";
    ModelArtifactScalarFieldEnum["version"] = "version";
    ModelArtifactScalarFieldEnum["artifactType"] = "artifactType";
    ModelArtifactScalarFieldEnum["storageUrl"] = "storageUrl";
    ModelArtifactScalarFieldEnum["storageProvider"] = "storageProvider";
    ModelArtifactScalarFieldEnum["fileSize"] = "fileSize";
    ModelArtifactScalarFieldEnum["checksum"] = "checksum";
    ModelArtifactScalarFieldEnum["compressionType"] = "compressionType";
    ModelArtifactScalarFieldEnum["metadataFramework"] = "metadataFramework";
    ModelArtifactScalarFieldEnum["metadataPythonVersion"] = "metadataPythonVersion";
    ModelArtifactScalarFieldEnum["metadataDependencies"] = "metadataDependencies";
    ModelArtifactScalarFieldEnum["metadataTrainingDate"] = "metadataTrainingDate";
    ModelArtifactScalarFieldEnum["metadataDatasetSize"] = "metadataDatasetSize";
    ModelArtifactScalarFieldEnum["metadataHyperparameters"] = "metadataHyperparameters";
    ModelArtifactScalarFieldEnum["createdAt"] = "createdAt";
    ModelArtifactScalarFieldEnum["updatedAt"] = "updatedAt";
})(ModelArtifactScalarFieldEnum || (ModelArtifactScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ModelArtifactScalarFieldEnum, {
    name: "ModelArtifactScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ModelArtifactScalarFieldEnum.js.map